export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <span className={light ? "grid h-14 w-14 place-items-center rounded-2xl bg-white p-1.5" : ""}>
      <img src="/images/logo-mega-solar.png" alt="" aria-hidden="true" width="43" height="50"
        className={light ? "h-11 w-auto" : "h-12 w-auto"} />
    </span>
    <span className={`font-display text-[1.35rem] leading-none tracking-tight ${light ? "text-white" : "text-forest"}`}>
      <span className="font-semibold">MEGA</span>
      <span className="font-normal opacity-80"> SOLAR</span>
    </span>
  </span>
);
